import {useContext} from "react";
import {LoaderContext} from "../providers/LoaderProvider";

export function useLoader() {
    return useContext(LoaderContext)!;
}
